<template>
  <a-modal
    :title="title"
    :visible="visible"
    @ok="handleOk"
    @cancel="handleCancel"
    :confirmLoading="confirmLoading"
  >
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item :label="$t('class.form.name.label')" prop="name">
        <a-input v-model="form.name" :placeholder="$t('class.form.name.placeholder')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('class.form.major.label')" prop="majorId" v-if="form.classType === '1'">
        <a-cascader
          v-model="form.majorId"
          class="search-item"
          :options="majorOptions"
          :placeholder="$t('class.form.major.placeholder')"
          @change="handleMajorChange"
          :disabled="editData"
        >
        </a-cascader>
      </a-form-model-item>
      <a-form-model-item :label="$t('class.form.teacher.label')" prop="teacherIds" style="margin-bottom: 6px">
        <div class="search-item">
          <a-select
            v-model="form.teacherIds"
            mode="multiple"
            :placeholder="$t('class.form.teacher.placeholder')"
            :filterOption="filterTeacherOption"
            showSearch
          >
            <a-select-option v-for="teacher in teacherOptions" :key="teacher.value" :value="teacher.value">
              {{ teacher.label }}
            </a-select-option>
          </a-select>
          <img class="searchIcon" src="@/assets/icons/icon_s@2x.png" alt="">
        </div>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import { classSave, getTeacherListAll, classDetail } from '@/api/admin'
import { getAdminOrgList } from '@/api/lesson'

export default {
  name: 'ClassFormModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: function() {
        return this.$t('class.createClass')
      }
    },
    editData: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      confirmLoading: false,
      form: {
        name: '',
        classType: undefined,
        teacherIds: [],
        majorId: undefined
      },
      rules: {
        name: [
          { required: true, message: this.$t('class.form.name.required'), trigger: 'blur' },
          { max: 30, message: this.$t('class.form.name.maxLength'), trigger: 'blur' }
        ],
        classType: [
          { required: true, message: this.$t('class.form.classType.required'), trigger: 'change' }
        ],
        teacherIds: [
          { required: true, type: 'array', message: this.$t('class.form.teacher.required'), trigger: 'change' }
        ],
        majorId: [
          { required: true, message: this.$t('class.form.major.required'), trigger: 'change' }
        ]
      },
      majorOptions: [],
      teacherOptions: []
    }
  },
  watch: {
    async visible(val) {
      console.log(val)
      if (val) {
        console.log(this.editData)
        this.getMajorList()
        this.getTeachers()
        // 如果是编辑模式，填充表单数据
        if (this.editData) {
          // 处理编辑数据
          const formData = { ...this.editData }
          const res = await classDetail({
            id: this.editData.id
          })
          if (res.code === 200) {
            formData.majorId = [res.data.collegeId, res.data.departmentId, res.data.professionId]
          }
          this.form = formData
          this.$nextTick(() => {
            // this.form.majorId = this.editData
          })
        }
      } else {
        this.resetForm()
      }
    }
  },
  methods: {
    resetForm() {
      this.$refs.form && this.$refs.form.resetFields()
      this.form = {
        name: '',
        classType: undefined,
        teacherIds: [],
        majorId: undefined
      }
    },
    handleCancel() {
      this.$emit('cancel')
      this.resetForm()
    },
    async handleOk() {
      try {
        const valid = await this.$refs.form.validate()
        if (valid) {
          this.confirmLoading = true
          if (this.form.classType === '1') {
            this.form.collegeId = this.form.majorId[0]
            this.form.departmentId = this.form.majorId[1]
            this.form.professionId = this.form.majorId[2]
          }
          const res = await classSave(Object.assign(this.form, {
            classType: '2'
          }))
          if (res.code === 200) {
            this.$message.success(this.$t('class.form.operationSuccess'))
            this.$emit('success')
            this.resetForm()
          }
        }
      } catch (error) {
        console.error('操作班级失败:', error)
        this.$message.error(this.$t('class.form.operationFailed'))
      } finally {
        this.confirmLoading = false
      }
    },
    async getMajorList() {
      try {
        const res = await getAdminOrgList()
        if (res.code === 200) {
          // 转换数据格式为树形结构
          this.majorOptions = []
          for (const item of res.data.list) {
            this.majorOptions.push({
              value: item.id,
              label: item.name,
              children: item.child.map(items => {
                return {
                  value: items.id,
                  label: items.name,
                  children: items.child.map(itemt => {
                    return {
                      value: itemt.id,
                      label: itemt.name
                    }
                  })
                }
              })
            })
          }
        }
      } catch (error) {
        console.error('获取专业列表失败:', error)
        this.$message.error(this.$t('class.form.getMajorFailed'))
      }
    },
    async getTeachers() {
      try {
        const res = await getTeacherListAll({
          status: '1'
        })
        if (res.code === 200) {
          this.teacherOptions = res.data.list.map(teacher => ({
            label: teacher.name,
            value: teacher.id
          }))
        }
      } catch (error) {
        console.error('获取教师列表失败:', error)
        this.$message.error(this.$t('class.form.getTeacherFailed'))
      }
    },
    handleMajorChange(value) {
      this.form.majorId = value
    },
    filterTeacherOption(input, option) {
      if (!input || !option || !option.componentOptions || !option.componentOptions.children) {
        return true
      }
      
      // 获取选项文本内容
      const text = option.componentOptions.children[0].text || ''
      return text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    }
  }
}
</script>

<style lang="less" scoped>
.search-item {
  width: 100%;
}
/deep/ .ant-modal-body {
  padding: 24px 24px 0;
}
/deep/ .ant-select {
  width: 100%;
}
/deep/ .ant-cascader-picker {
  width: 100%;
}
/deep/ .ant-form-item-label{
  height: 34px;
}
/deep/ .search-item{
  position: relative;
  width: 100%;
  .searchIcon{
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    color: #999;
    width: 16px;
    height: 16px;
    line-height: 20px;
    text-align: center;
    opacity: 0.7;
  }
}
</style>
